(function (window, document) {
'use strict';
var core = window.scUpsellCore;
if (!core || window.__scUpsellProduct) return;
var CONTAINER_SELECTOR = '[data-sc-product-upsells]';
var OFFER_SELECTOR = '[data-sc-upsell-offer][data-sc-upsell-enabled="true"]';
var containers = [];
var seenImpressions = Object.create(null);
var analyticsEvents = Object.create(null);
var afterProofs = Object.create(null);
var nextFieldIndex = 700000000;
var observer = null;
var pollTimer = null;
window.__scUpsellProduct = {
installed: true,
refresh: scan
};
function emit(name, root, detail) {
var offerId = root && root.getAttribute('data-sc-upsell-offer-id') || '';
var operationId = detail && detail.operationId || '';
var eventId = [name, offerId, operationId].join(':');
if (operationId && analyticsEvents[eventId]) return;
if (operationId) analyticsEvents[eventId] = true;
document.dispatchEvent(new window.CustomEvent('sc:upsell-analytics', {
detail: Object.assign({
event: name,
eventId: eventId,
offerId: offerId,
kind: root && root.getAttribute('data-sc-upsell-kind') || '',
behavior: root && root.getAttribute('data-sc-upsell-behavior') || '',
relationship: root && root.getAttribute('data-sc-upsell-relationship') || ''
}, detail || {})
}));
}
function markError(root, error) {
root.setAttribute('data-sc-upsell-config-valid', 'false');
root.setAttribute('data-sc-upsell-error', error && error.code || 'E_SC_UPSELL_CONFIG');
var status = root.querySelector('[data-sc-upsell-status]');
if (status) status.textContent = 'This offer is temporarily unavailable.';
}
function configOf(root) {
return core.normalizeOfferConfig({
offerId: root.getAttribute('data-sc-upsell-offer-id'),
behavior: root.getAttribute('data-sc-upsell-behavior'),
relationship: root.getAttribute('data-sc-upsell-relationship'),
kind: root.getAttribute('data-sc-upsell-kind'),
position: root.getAttribute('data-sc-upsell-position'),
quantityPolicy: root.getAttribute('data-sc-upsell-quantity-policy')
});
}
function formOf(root) {
var formId = root.getAttribute('data-sc-upsell-form-id') || '';
return formId ? document.getElementById(formId) : null;
}
function mainVariantId(root) {
var form = formOf(root);
if (!form || !form.elements) return '';
var control = typeof form.elements.namedItem === 'function' ? form.elements.namedItem('id') : null;
return control && /^\d+$/.test(String(control.value || '')) ? String(control.value) : '';
}
function afterRoots(formId) {
return Array.prototype.filter.call(document.querySelectorAll(OFFER_SELECTOR), function (root) {
return root.dataset.scUpsellFormId === formId
&& root.dataset.scUpsellBehavior === 'after'
&& root.dataset.scUpsellConfigValid === 'true';
});
}
function additionalGroupCount(form) {
var groups = Object.create(null);
var controls = form.elements || [];
for (var i = 0; i < controls.length; i += 1) {
var control = controls[i];
var match = !control.disabled && String(control.name || '').match(/^items\[([^\]]+)\]/);
if (match) groups[match[1]] = true;
}
return Object.keys(groups).length;
}
function field(root, role) {
return root.querySelector('[data-sc-upsell-form-field][data-sc-upsell-field-role="' + role + '"]');
}
function assignFieldIndex(root) {
if (root.getAttribute('data-sc-upsell-field-index-assigned') === 'true') return;
var index = String(nextFieldIndex);
nextFieldIndex += 1;
var fields = root.querySelectorAll('[data-sc-upsell-form-field][name]');
for (var i = 0; i < fields.length; i += 1) {
fields[i].name = fields[i].name.replace(/^items\[[0-9]{1,10}\]/, 'items[' + index + ']');
}
root.setAttribute('data-sc-upsell-field-index', index);
root.setAttribute('data-sc-upsell-field-index-assigned', 'true');
}
function syncAfterFields(root, forceNewOperation) {
if (root.getAttribute('data-sc-upsell-behavior') !== 'after') return;
var checkbox = root.querySelector('[data-sc-upsell-checkbox]');
var enabled = !!(checkbox && checkbox.checked && root.getAttribute('data-sc-upsell-config-valid') === 'true');
var fields = root.querySelectorAll('[data-sc-upsell-form-field]');
var operation = field(root, 'operation');
var parent = field(root, 'parent');
var variant = field(root, 'variant');
var selectedVariant = root.getAttribute('data-sc-upsell-variant-id') || '';
if (variant) variant.value = selectedVariant;
if (parent) {
var parentVariant = mainVariantId(root);
if (!parentVariant) enabled = false;
else parent.value = parentVariant;
}
if (enabled && operation && (forceNewOperation || !operation.value)) {
operation.value = core.makeOperationId();
}
for (var i = 0; i < fields.length; i += 1) fields[i].disabled = !enabled;
root.classList.toggle('is-selected', enabled);
root.setAttribute('data-selected', enabled ? 'true' : 'false');
}
function observeImpression(root) {
var offerId = root.getAttribute('data-sc-upsell-offer-id') || '';
if (!offerId || seenImpressions[offerId]) return;
function publish() {
if (seenImpressions[offerId]) return;
seenImpressions[offerId] = true;
emit('impression', root);
}
if (typeof window.IntersectionObserver !== 'function') return publish();
var impressionObserver = new window.IntersectionObserver(function (entries) {
if (entries.some(function (entry) { return entry.isIntersecting; })) {
impressionObserver.disconnect();
publish();
}
});
impressionObserver.observe(root);
}
function configureOffer(root) {
if (root.getAttribute('data-sc-upsell-configured') !== 'true') {
root.setAttribute('data-sc-upsell-configured', 'true');
var config;
try {
config = configOf(root);
if (config.behavior === 'after' && !formOf(root)) {
  throw core.makeError('E_SC_UPSELL_FORM', 'Owned product form unavailable');
}
} catch (error) {
markError(root, error);
return;
}
root.setAttribute('data-sc-upsell-config-valid', 'true');
root.setAttribute('data-sc-upsell-direct', config.direct ? 'true' : 'false');
if (config.behavior === 'after') assignFieldIndex(root);
observeImpression(root);
}
var checkbox = root.querySelector('[data-sc-upsell-checkbox]');
if (checkbox) checkbox.disabled = false;
syncAfterFields(root, false);
}
function suspendOffers(container) {
var offers = container.querySelectorAll(OFFER_SELECTOR);
for (var i = 0; i < offers.length; i += 1) {
var checkbox = offers[i].querySelector('[data-sc-upsell-checkbox]');
if (checkbox) checkbox.disabled = true;
var fields = offers[i].querySelectorAll('[data-sc-upsell-form-field]');
for (var j = 0; j < fields.length; j += 1) fields[j].disabled = true;
}
}
// First selector resolving to EXACTLY ONE owned visible node wins; ambiguous ones are skipped.
function visibleTarget(container, list) {
var sels = String(list || '').split(',');
for (var k = 0; k < sels.length; k += 1) {
var found = sels[k].trim() && visibleTargetFor(container, sels[k].trim());
if (found) return found;
}
return null;
}
function visibleTargetFor(container, selector) {
var section = container.closest('[id^="shopify-section-"]');
if (!section) return null;
var formId = container.dataset.scUpsellProductFormId || '';
// Unowned placement (CustomAll: its CTA renders in the app's own section, outside the form):
// any visible target anywhere on the page qualifies.
var anyOwner = container.getAttribute('data-sc-upsell-placement-owned') === 'false';
var matches;
try { matches = (anyOwner ? document : section).querySelectorAll(selector); } catch (e) { return null; }
var visible = [];
for (var i = 0; i < matches.length; i += 1) {
var target = matches[i];
if (target === container || container.contains(target)) continue;
var ownerForm = target.closest && target.closest('form');
// PZ mount declares its product form via data-pz-form-id: that is ownership too.
var pz = target.closest && target.closest('[data-pz-form-id]');
if (!anyOwner && (!ownerForm || ownerForm.getAttribute('id') !== formId)
&& target.getAttribute('form') !== formId
&& !(pz && pz.getAttribute('data-pz-form-id') === formId)) continue;
var style = window.getComputedStyle ? window.getComputedStyle(target) : null;
if (!style || (style.display !== 'none' && style.visibility !== 'hidden')) visible.push(target);
}
return visible.length === 1 ? visible[0] : null;
}
function place(entry) {
var container = entry.node;
var selector = container.getAttribute('data-sc-upsell-placement-selector') || '';
var position = container.getAttribute('data-sc-upsell-placement-position') || 'before';
var wait = container.getAttribute('data-sc-upsell-placement-wait') === 'true';
var target = null;
try {
target = selector.trim() ? visibleTarget(container, selector) : null;
} catch (error) {
container.setAttribute('data-sc-upsell-placement-error', 'invalid-selector');
container.hidden = true;
suspendOffers(container);
return false;
}
if (!selector.trim()) {
container.hidden = false;
container.setAttribute('data-sc-upsell-placement-ready', 'true');
return true;
}
if (!target) {
container.hidden = true;
suspendOffers(container);
if (!wait || Date.now() - entry.startedAt >= 30000) {
container.setAttribute('data-sc-upsell-placement-error', 'target-unavailable');
}
return false;
}
if (position === 'after') {
if (target.nextElementSibling !== container) target.insertAdjacentElement('afterend', container);
} else if (target.previousElementSibling !== container) {
target.insertAdjacentElement('beforebegin', container);
}
container.hidden = false;
container.setAttribute('data-sc-upsell-placement-ready', 'true');
container.removeAttribute('data-sc-upsell-placement-error');
return true;
}
function refreshPlacements() {
containers = containers.filter(function (entry) {
if (!entry.node.isConnected && Date.now() - entry.startedAt >= 30000) return false;
if (!place(entry)) return true;
var offers = entry.node.querySelectorAll(OFFER_SELECTOR);
for (var i = 0; i < offers.length; i += 1) configureOffer(offers[i]);
return true;
});
}
function discoverContainers(scope) {
var owner = scope && scope.querySelectorAll ? scope : document;
var found = [];
if (owner.matches && owner.matches(CONTAINER_SELECTOR)) found.push(owner);
Array.prototype.push.apply(found, owner.querySelectorAll(CONTAINER_SELECTOR));
found.forEach(function (node) {
if (containers.some(function (entry) { return entry.node === node; })) return;
containers.push({ node: node, startedAt: Date.now(), target: null });
});
}
function scan(scope) {
discoverContainers(scope);
refreshPlacements();
}
function updateVariant(root, select) {
var option = select.options[select.selectedIndex];
root.setAttribute('data-sc-upsell-variant-id', select.value);
var price = root.querySelector('[data-sc-upsell-price]');
var compare = root.querySelector('[data-sc-upsell-compare-price]');
if (price && option) price.textContent = option.getAttribute('data-price-label') || '';
if (compare && option) {
var compareLabel = option.getAttribute('data-compare-label') || '';
compare.textContent = compareLabel;
compare.classList.toggle('hidden', !compareLabel);
}
syncAfterFields(root, true);
}
function openDialog(button) {
var root = button.closest(OFFER_SELECTOR);
var dialogId = button.getAttribute('aria-controls') || '';
var dialog = dialogId && document.getElementById(dialogId);
if (!root || !dialog) return;
dialog.__scReturnFocus = button;
if (typeof dialog.showModal === 'function') dialog.showModal();
else dialog.setAttribute('open', '');
emit('more_information_opened', root);
}
function closeDialog(button) {
var dialog = button.closest('[data-sc-upsell-dialog]');
if (!dialog) return;
if (typeof dialog.close === 'function') dialog.close();
else dialog.removeAttribute('open');
}
// C1 (owner 10/10): one cart.js read per submit for all offers, after /cart/add settles (resource
// timing, any fetch path) or at the old 10 s horizon. No 500 ms poll.
function proveAfterAdd(roots, done) {
var snaps = roots.map(snapshotOffer);
var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';
var ops = roots.map(function (root) { var f = field(root, 'operation'); return f && f.value || ''; });
var read = false, observer = null, cap, hit = false;
function settle(cart) {
roots.forEach(function (root, index) {
var line = cart && matchAfterLine(snaps[index], ops[index], cart.items);
if (line) emit('add_confirmed', root, { operationId: ops[index], variantId: String(line.variant_id) });
else emit('failure', root, { operationId: ops[index], code: cart ? 'E_SC_UPSELL_AFTER_UNCONFIRMED' : 'E_SC_UPSELL_AFTER_CART_UNAVAILABLE' });
done();
});
}
function check() {
if (read) return;
read = true;
window.clearTimeout(cap);
if (observer) observer.disconnect();
window.fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
.then(function (response) { return response.ok ? response.json() : null; })
.then(function (cart) { settle(cart && Array.isArray(cart.items) ? cart : null); }, function () { settle(null); });
}
cap = window.setTimeout(function () { if (observer && !hit) { observer.disconnect(); roots.forEach(done); } else check(); }, 10000);
try {
observer = new window.PerformanceObserver(function (list) {
if (list.getEntries().some(function (entry) { return /\/cart\/add(\.js)?(\?|$)/.test(entry.name); })) { hit = true; window.setTimeout(check, 300); }
});
observer.observe({ type: 'resource' });
} catch (e) { window.clearTimeout(cap); cap = window.setTimeout(check, 4000); }
}
function snapshotOffer(root) { return { dataset: Object.assign({}, root.dataset), main: mainVariantId(root) }; }
function matchAfterLine(root, operationId, items) {
var offerId = root.dataset.scUpsellOfferId;
var kind = root.dataset.scUpsellKind;
var variantId = root.dataset.scUpsellVariantId;
var triggerId = root.dataset.scUpsellTriggerProductId;
var strictChild = root.dataset.scUpsellRelationship === 'strict_child';
var matches = items.filter(function (item) {
var properties = item.properties || {};
return String(properties._sc_offer_id || '') === offerId
&& String(properties._sc_offer_operation_id || '') === operationId
&& String(properties._sc_offer_kind || '') === kind
&& String(properties._sc_offer_trigger_product_id || '') === triggerId
&& String(item.variant_id) === variantId
&& Number(item.quantity) === 1
&& (!strictChild || !!item.parent_relationship);
});
var line = matches.length === 1 ? matches[0] : null;
if (line && strictChild) {
var relationship = line.parent_relationship || {};
var parentKey = relationship.parent_key || relationship.parent && relationship.parent.key || '';
var parents = items.filter(function (item) { return String(item.key || '') === String(parentKey); });
var parent = parents.length === 1 ? parents[0] : null;
if (!parent || String(parent.variant_id) !== root.main) line = null;
if (line && root.dataset.scUpsellProvider === 'inhouse') {
var childBinding = String((line.properties || {})._pz_parent_operation_id || '');
line = childBinding
&& childBinding === String((parent.properties || {})._pz_operation_id || '') ? line : null;
}
}
return line;
}
document.addEventListener('change', function (event) {
var target = event.target;
if (!target || !target.closest) return;
var root = target.closest(OFFER_SELECTOR);
if (!root || root.getAttribute('data-sc-upsell-config-valid') !== 'true') return;
if (target.matches('[data-sc-upsell-variant]')) {
updateVariant(root, target);
return;
}
if (!target.matches('[data-sc-upsell-checkbox]')) return;
syncAfterFields(root, true);
emit('intent_changed', root, {
checked: !!target.checked,
variantId: root.getAttribute('data-sc-upsell-variant-id') || ''
});
});
function handleAfterSubmit(event, form) {
var formId = form && form.getAttribute && form.getAttribute('id') || '';
if (!formId) return;
var roots = afterRoots(formId);
if (!roots.length) return;
var joined = !!form.querySelector('.pz-atc-commit-busy,[aria-busy="true"]');
roots.forEach(function (root) { syncAfterFields(root, !joined); });
var selected = roots.filter(function (root) {
var checkbox = root.querySelector('[data-sc-upsell-checkbox]');
return !!(checkbox && checkbox.checked);
});
var reserve = roots.some(function (root) {
return root.dataset.scUpsellProvider === 'inhouse';
}) ? 1 : 0;
if (additionalGroupCount(form) + reserve > 8) {
event.preventDefault();
event.stopImmediatePropagation();
selected.forEach(function (root) {
var operation = field(root, 'operation');
emit('failure', root, { operationId: operation && operation.value || '', code: 'E_SC_UPSELL_ITEMS_LIMIT' });
var status = root.querySelector('[data-sc-upsell-status]');
if (status) status.textContent = 'Too many add-ons are selected.';
});
return;
}
if (joined || !selected.length) return;
afterProofs[formId] = (afterProofs[formId] || 0) + selected.length;
proveAfterAdd(selected, function () {
afterProofs[formId] -= 1;
if (!afterProofs[formId]) delete afterProofs[formId];
});
}
window.addEventListener('submit', function (event) {
handleAfterSubmit(event, event.target);
}, true);
window.addEventListener('click', function (event) {
var button = event.target && event.target.closest
&& event.target.closest('[id^="SectionAtcBtn-"][form],.pz-preview-modal__atc[data-pz-preview-submit-ready="true"]');
  if (!button || button.closest('[data-pz-mode="edit"]')) return;
  var formId = button.getAttribute('form') || '';
  if (!formId) {
    var dialog = button.closest('[aria-labelledby^="pz-preview-title-"]');
    var titleId = dialog && dialog.getAttribute('aria-labelledby') || '';
    var sectionId = titleId.replace(/^pz-preview-title-/, '');
    var section = document.getElementById('shopify-section-' + sectionId);
    var mount = section && section.querySelector('[data-pz-storefront]');
    if (!mount || mount.getAttribute('data-pz-mode') === 'edit') return;
    var offer = section && section.querySelector(OFFER_SELECTOR + '[data-sc-upsell-provider="inhouse"]');
formId = offer && offer.dataset.scUpsellFormId || '';
}
if (formId) handleAfterSubmit(event, document.getElementById(formId));
}, true);
document.addEventListener('click', function (event) {
var open = event.target && event.target.closest && event.target.closest('[data-sc-upsell-dialog-open]');
if (open) return openDialog(open);
var close = event.target && event.target.closest && event.target.closest('[data-sc-upsell-dialog-close]');
if (close) closeDialog(close);
});
document.addEventListener('close', function (event) {
var dialog = event.target;
if (!dialog || !dialog.matches || !dialog.matches('[data-sc-upsell-dialog]')) return;
if (dialog.__scReturnFocus && typeof dialog.__scReturnFocus.focus === 'function') dialog.__scReturnFocus.focus();
}, true);
document.addEventListener('sc:upsell-confirmed', function (event) {
var detail = event.detail || {};
var offerId = String(detail.offerId || '');
var parentOperationId = String(detail.parentOperationId || '');
var parentKey = String(detail.parentKey || '');
var root = Array.prototype.find.call(document.querySelectorAll(OFFER_SELECTOR), function (candidate) {
return candidate.getAttribute('data-sc-upsell-offer-id') === offerId
&& String(candidate.getAttribute('data-sc-upsell-parent-operation-id') || '') === parentOperationId
&& String(candidate.getAttribute('data-sc-upsell-parent-key') || '') === parentKey;
});
if (!root) return;
emit(detail.action === 'remove' ? 'remove_confirmed' : 'add_confirmed', root, detail);
});
document.addEventListener('shopify:section:unload', function (event) {
var owner = event.target;
containers = containers.filter(function (entry) {
return !owner || !owner.contains || !owner.contains(entry.node);
});
});
function install() {
scan(document);
if (typeof window.MutationObserver === 'function' && document.body) {
observer = new window.MutationObserver(function (mutations) {
// Discover the whole batch before refreshing placements once for all containers.
mutations.forEach(function (mutation) {
  for (var i = 0; i < mutation.addedNodes.length; i += 1) {
    var node = mutation.addedNodes[i];
    if (node && node.nodeType === 1) discoverContainers(node);
  }
});
refreshPlacements();
});
observer.observe(document.body, { childList: true, subtree: true });
}
pollTimer = window.setInterval(refreshPlacements, 400);
window.setTimeout(function () {
if (pollTimer) window.clearInterval(pollTimer);
pollTimer = null;
}, 30000);
}
// CustomAll: the SDK serialises ITS OWN form into a JSON cart/add body and never reads the theme
// form, so an unowned (placement-owned=false) After offer is carried by intercepting that one
// request: append the offer as a strict child of the SDK's first item, once, only while the
// shopper's checkbox is checked. Everything else about the request is untouched; non-JSON
// bodies pass through.
function installSdkBridge() {
if (window.__scUpsellSdkBridge || typeof window.fetch !== 'function') return;
window.__scUpsellSdkBridge = true;
var nativeFetch = window.fetch;
window.fetch = function (input, init) {
try {
var url = typeof input === 'string' ? input : (input && input.url) || '';
var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
var body = JSON.parse(init.body);
if (body && Array.isArray(body.items) && body.items.length) {
var offers = Array.prototype.filter.call(document.querySelectorAll('[data-sc-product-upsells][data-sc-upsell-placement-owned="false"] ' + OFFER_SELECTOR), function (root) {
return root.getAttribute('data-sc-upsell-config-valid') === 'true' && root.getAttribute('data-sc-upsell-behavior') === 'after';
});
if (offers.length) {
var main = body.items[0];
offers.forEach(function (root) {
var checkbox = root.querySelector('[data-sc-upsell-checkbox]');
var variantId = root.getAttribute('data-sc-upsell-variant-id') || '';
if (!checkbox || !checkbox.checked || !/^\d+$/.test(variantId) || !main || !main.id) return;
if (body.items.some(function (item) { return String(item.id) === variantId; })) return;
var operation = field(root, 'operation');
if (operation && !operation.value) operation.value = core.makeOperationId();
var child = { id: Number(variantId), quantity: 1, parent_id: Number(main.id), properties: {} };
var props = root.querySelectorAll('[data-sc-upsell-form-field][name*="[properties]["]');
for (var i = 0; i < props.length; i += 1) {
var m = /\[properties\]\[([^\]]+)\]$/.exec(props[i].name || '');
if (m) child.properties[m[1]] = props[i].value;
}
body.items.push(child);
emit('sdk_bridge_attached', root, { operationId: operation ? operation.value : '' });
});
init = Object.assign({}, init, { body: JSON.stringify(body) });
}
}
}
} catch (e) { /* pass the request through untouched */ }
return nativeFetch.call(this, input, init);
};
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install);
else install();
installSdkBridge();
})(window, document);
